document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Get all product images
    const images = document.querySelectorAll('.product__media-item .media img');
    const imageUrls = [];
    
    images.forEach(function(img) {
      const imgSrc = img.src.split('?')[0];
      imageUrls.push({
        src: imgSrc,
        type: 'image',
        thumb: img.src,
        caption: img.alt || ''
      });
      img.style.cursor = 'pointer';
    });
    
    // Capture clicks on the entire media gallery container
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery) {
      mediaGallery.addEventListener('click', function(e) {
        const clickedImg = e.target.closest('.product__media-item .media img');
        if (clickedImg) {
          e.preventDefault();
          e.stopImmediatePropagation();
          
          const index = Array.from(images).indexOf(clickedImg);
          
          if (typeof Fancybox !== 'undefined' && index >= 0) {
            Fancybox.show(imageUrls, {
              startIndex: index,
              Toolbar: {
                display: {
                  left: ["infobar"],
                  middle: [],
                  right: ["close"],
                },
              },
              Thumbs: {
                autoStart: true,
                type: "classic",
              },
            });
          }
        }
      }, { capture: true });
    }
    
    console.log('Fancybox ready with ' + images.length + ' images');
  }, 500);
});